import Modal from "@mui/material/Modal";
import React from "react";
import {Box, IconButton, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon} from "@hugeicons/core-free-icons";
import * as Diff from "diff";
import {UI, rgba} from "../../uiTokens";
import {iconBtnSx, modalCardSx} from "../editMenuStyles";

// A part only belongs to one side: the left (old) side skips additions, the right (new) side skips removals,
// so each column reads as that version's own full text rather than one jumbled stream.
const renderSide = (parts, side) => parts
    .filter(part => (side === "left" ? !part.added : !part.removed))
    .map((part, index) => {
        let backgroundColor = "transparent";
        let color = "inherit";
        let textDecoration = "none";
        if (side === "left" && part.removed) {
            backgroundColor = "#ffebe9";
            color = "#c93026";
            textDecoration = "line-through";
        } else if (side === "right" && part.added) {
            backgroundColor = "#e6ffec";
            color = "#24693d";
        }
        return (
            <Typography key={index} component="span" sx={{backgroundColor, color, textDecoration, fontSize: "inherit", fontFamily: "inherit"}}>
                {part.value}
            </Typography>
        );
    });

const columnSx = {
    border: `1px solid ${rgba(UI.ink, 0.08)}`, borderRadius: "10px", p: 1.5,
    maxHeight: "60vh", overflow: "auto", fontSize: 12.5, lineHeight: 1.6, fontFamily: "monospace", whiteSpace: "pre-wrap",
};

export const SystemPromptDiffModal = ({open, onClose, left, right}) => {
    const parts = Diff.diffWords(left?.value || "", right?.value || "");

    return (
        <Modal open={open} onClose={onClose} aria-labelledby="system-prompt-diff-title">
            <Box sx={{...modalCardSx, maxWidth: 920}}>
                <Stack direction="row" gap={1} alignItems="center" sx={{mb: 1.5}}>
                    <Typography id="system-prompt-diff-title" sx={{flex: 1, fontWeight: 700, fontSize: 16, color: UI.ink}}>
                        Comparing versions
                    </Typography>
                    <IconButton size="small" onClick={onClose} sx={iconBtnSx}>
                        <HugeiconsIcon icon={Cancel01Icon} size={18}/>
                    </IconButton>
                </Stack>

                <Stack direction={{xs: "column", sm: "row"}} gap={1.5}>
                    <Box sx={{flex: 1, minWidth: 0}}>
                        <Typography sx={{fontSize: 11.5, fontWeight: 700, color: "#c93026", mb: 0.75}}>− {left?.label}</Typography>
                        <Box sx={columnSx}>{renderSide(parts, "left")}</Box>
                    </Box>
                    <Box sx={{flex: 1, minWidth: 0}}>
                        <Typography sx={{fontSize: 11.5, fontWeight: 700, color: "#24693d", mb: 0.75}}>+ {right?.label}</Typography>
                        <Box sx={columnSx}>{renderSide(parts, "right")}</Box>
                    </Box>
                </Stack>
            </Box>
        </Modal>
    );
};
